import { useRouter } from "vue-router";

export default function useAuthHelper() {
    const router = useRouter();

    const redirectIfAuthenticated = async () => {
        const isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));
        const isVerified = JSON.parse(localStorage.getItem("isVerified"));
        const isAgencyConfigured = JSON.parse(localStorage.getItem("isAgencyConfigured"));

        /*
         * redirect to Dashboard if
         * user is authenticated, email is verified, agency is configured
         */
        if (isAuthenticated && isVerified && isAgencyConfigured) {
            await router.push({ name: "dashboard", });
        }

        /*
         * redirect to Verify Email page if
         * user is authenticated, email is not verified
         */
        if (isAuthenticated && !isVerified) {
            await router.push({ name: "verify-email", });
        }

        /*
        * redirect to Agency Details page if
        * user is authenticated, email is verified and agency is not configured
        */
        if (isAuthenticated && isVerified && !isAgencyConfigured) {
            await router.push({ path: "/agency/agency-info", });
        }
    };

    return {
        redirectIfAuthenticated,
    };
}
